import { Dialog, Typography, List, ListItem, Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { diff, Diff } from 'deep-diff';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface IProps {
  oldValue: any;
  newValue: any;
}

const DIFF = {
  evidence: 'Evidence',
  assetCategory: 'Category',
  status: 'Status',
  note: 'Note',
};

const CompareCell = (props: IProps) => {
  const { oldValue, newValue } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const [diffResult, setDiffResult] = useState<Diff<any>[] | null>(null);

  useEffect(() => {
    const differences = diff(oldValue, newValue);
    setDiffResult(differences ?? null);
  }, [oldValue, newValue]);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleClickAway = () => setMenuOpen(false);

  const _renderChange = (change: any) => {
    const { kind, lhs, rhs } = change;

    switch (kind) {
      case 'E':
        return (
          <Box sx={{ wordBreak: 'break-word' }} display="flex" alignItems="center" gap="4px">
            <Typography component="span" sx={{ color: '#FF4848', whiteSpace: 'pre-wrap' }}>
              {lhs}
            </Typography>
            <ArrowForwardIcon />
            <Typography component="span" sx={{ color: '#9DD049', whiteSpace: 'pre-wrap' }}>
              {rhs}
            </Typography>
          </Box>
        );
      case 'N':
        return (
          <Box sx={{ wordBreak: 'break-word' }} display="flex" alignItems="center" gap="4px">
            <span>{'New Item Added'}</span>
            <ArrowForwardIcon />
            <Typography component="span" sx={{ color: '#9DD049', whiteSpace: 'pre-wrap' }}>
              {rhs}
            </Typography>
          </Box>
        );
      case 'D':
        return (
          <Box sx={{ wordBreak: 'break-word' }} display="flex" alignItems="center" gap="4px">
            <Typography component="span" sx={{ color: '#FF4848', whiteSpace: 'pre-wrap' }}>
              {lhs}
            </Typography>
            <ArrowForwardIcon />
            <span>{'Item Deleted'}</span>
          </Box>
        );
      default:
        return null;
    }
  };

  const _renderDiff = () => {
    if (!diffResult || diffResult.length === 0) {
      return <p>No differences found.</p>;
    }

    return (
      <List>
        {diffResult
          .filter((change: any) => {
            return change.path && change.path.length && DIFF[change.path[0] as keyof typeof DIFF];
          })
          .map((change: any, index: number) => (
            <ListItem key={index} disablePadding>
              <Typography component="span">
                <Typography component="span" fontWeight={600}>
                  {`${index + 1}.`}&nbsp;&nbsp;
                  {DIFF[change.path[0] as keyof typeof DIFF]}
                  {':'}&nbsp;
                </Typography>
              </Typography>
              {_renderChange(change)}
            </ListItem>
          ))}
      </List>
    );
  };

  return (
    <>
      <Typography
        sx={{
          fontSize: '9px',
          lineHeight: '20px',
          fontWeight: '500',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
        onClick={toggleMenu}
      >
        Compare
      </Typography>
      {menuOpen && (
        <Dialog
          open={menuOpen}
          onClose={handleClickAway}
          PaperProps={{
            style: {
              padding: '20px 70px',
              width: 'fit-content',
              borderRadius: '24px',
              maxWidth: '800px',
            },
          }}
        >
          {_renderDiff()}
        </Dialog>
      )}
    </>
  );
};

export default CompareCell;
